// extracted by mini-css-extract-plugin
export default {"container":"BenfitCard_container__WoPPE","header":"BenfitCard_header__9Fdue","text":"BenfitCard_text__3tCpi","button":"BenfitCard_button__nzdlD"};